// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1iE3G","boxTitle":"Qualiphy_boxTitle__36Ebk","box":"Qualiphy_box__LYv4F","toggleWrap":"Qualiphy_toggleWrap__2_3XF"};